import axios from 'axios';

const baseURL = `api/allcharacteristicvalues`;

export default {
    getAllCharacteristics() {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(baseURL);
    },
};
